const pageNameKey = "machineStructureFilter";

export const machineStructureFilterEn = {
  [pageNameKey]: {
    subtitle: "Machine Structure Filter",
    labelText: "Filter for names and ids",
    textAreaPlaceholder: "e.g. Temperature",
    showResults: "Show Results",
    clearFilter: "Clear Filter",
  },
};

export const machineStructureFilterPtBr = {
  [pageNameKey]: {
    subtitle: "Filtro de Estrutura da Máquina",
    labelText: "Filtrar por nomes e IDs",
    textAreaPlaceholder: "por exemplo, Temperatura",
    showResults: "Mostrar resultados",
    clearFilter: "Limpar filtro",
  },
};

export const machineStructureFilterDe = {
  [pageNameKey]: {
    subtitle: "Maschinenstrukturfilter",
    labelText: "Filter nach Namen und IDs",
    textAreaPlaceholder: "z.B.: Temperatur",
    showResults: "Ergebnisse anzeigen",
    clearFilter: "Filter zurücksetzen",
  },
};

export const machineStructureFilterZhHans = {
  [pageNameKey]: {
    subtitle: "机器结构过滤器",
    labelText: "按名称和ID过滤",
    textAreaPlaceholder: "例如：温度",
    showResults: "显示结果",
    clearFilter: "清除过滤器",
  },
};

export const machineStructureFilterIt = {
  [pageNameKey]: {
    subtitle: "Filtro struttura attiva",
    labelText: "Filtra per nomi e ID",
    textAreaPlaceholder: "es. Temperatura",
    showResults: "Mostra i risultati",
    clearFilter: "Rimuovi filtro",
  },
};

export const machineStructureFilterEs = {
  [pageNameKey]: {
    subtitle: "Filtro de estructura de la máquina",
    labelText: "Filtrar por nombres e id",
    textAreaPlaceholder: "p. ej., Temperatura",
    showResults: "Mostrar resultados",
    clearFilter: "Borrar filtro",
  },
};

export const machineStructureFilterNl = {
  [pageNameKey]: {
    clearFilter: "Filter wissen",
    labelText: "Filteren op namen en ID's",
    showResults: "Resultaten weergeven",
    subtitle: "Machinestructuurfilters",
    textAreaPlaceholder: "bijv. temperatuur",
  },
};

export const machineStructureFilterTr = {
  [pageNameKey]: {
    clearFilter: "Filtreyi Temizle",
    labelText: "Adlar ve kimlikler için filtreleyin",
    showResults: "Sonuçları Göster",
    subtitle: "Makine Yapısı Filtresi",
    textAreaPlaceholder: "örneğin Sıcaklık",
  },
};
